import { createTheme } from "@material-ui/core/styles";
import Theming, { wellColors } from "@welldigital/components/theming";

const theming = new Theming({
  breakpoints: {
    // not using welldigital/components theme since it is not mobile first friendly (xs must be 0)
    values: {
      lg: 1280,
      md: 960,
      sm: 600,
      xl: 1920,
      xs: 0,
    },
  },
  palette: {
    primary: {
      light: wellColors.zen[50],
      main: wellColors.zen[500],
      dark: wellColors.zen[900],
    },
    secondary: {
      light: wellColors.zen[50],
      main: wellColors.zen[50],
      dark: wellColors.zen[100],
      contrastText: wellColors.zen[900],
    },
    background: {
      default: "#fff",
    },
  },
  props: {
    MuiLink: {
      color: "inherit",
    },
  },
});

const theme = createTheme(theming);

export default theme;
